import { MIMETYPE_CSV } from 'cadenza/model/media-type';

import { AbstractTableExportAction } from './abstract-table-export-action';
import i18n from './export-to-csv-action.properties';

export class ExportToCsvAction extends AbstractTableExportAction {

  constructor (options = {}) {
    super(
      MIMETYPE_CSV,
      {
        ...options,
        label: i18n('action.label'),
        dialogTitle: i18n('dialog.title')
      });
  }

}
